export const numberRegex = /^[0-9]+$/;
